import { render, staticRenderFns } from "./BodyCompositionAnalysis.vue?vue&type=template&id=35f1f369"
import script from "./BodyCompositionAnalysis.vue?vue&type=script&lang=js"
export * from "./BodyCompositionAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports